"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenuFileButtons;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _OutboundLink = _interopRequireDefault(require("../../atoms/OutboundLink"));

var _MenuFileButtons = require("./MenuFileButtons.utils");

require("./MenuFileButtons.css");

function MenuFileButtons(props) {
  var files = props.files,
      button = props.button;

  if (files.length === 0) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, files.map(function (_ref, index) {
    var url = _ref.url,
        filename = _ref.filename;
    var buttonLabel = (0, _MenuFileButtons.resolveButtonLabel)(filename, files.length === 1);
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, (0, _extends2["default"])({}, button, {
      content: buttonLabel,
      className: "fc-menu-file-button",
      key: filename,
      as: function as(semProps) {
        return /*#__PURE__*/_react["default"].createElement(_OutboundLink["default"], (0, _extends2["default"])({}, semProps, {
          to: url,
          label: buttonLabel
        }));
      }
    }));
  }));
}

MenuFileButtons.propTypes = {
  files: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    url: _propTypes["default"].string,
    filename: _propTypes["default"].string
  })).isRequired,
  button: _propTypes["default"].object
};
MenuFileButtons.defaultProps = {
  button: {}
};